import type { InjectionKey } from 'vue'
import type { AppRoutes } from './app-router/app-routes'
import type { SidebarContextType } from '@/app/providers/sidebar/type'
import type { ThemaProviderType } from '@/app/providers/theme/type'
import type { AxiosInstance } from 'axios'

export const ProviderKeys = {
  AppRoutes: Symbol() as InjectionKey<typeof AppRoutes>,
  AppSidebar: Symbol() as InjectionKey<SidebarContextType>,
  AppTheme: Symbol() as InjectionKey<ThemaProviderType>,
  AppAxios: Symbol() as InjectionKey<AxiosInstance>,
  AppAxiosWeb: Symbol() as InjectionKey<AxiosInstance>,
}
